import type { SiteLocale } from "@/lib/i18n/config";
import { getBlogPageCopy } from "@/lib/blog-page-copy";
import { getProjectsPageCopy } from "@/lib/projects-page-copy";
import type { Lang } from "@/lib/types";

export function getBlogPreviewCardReadLabel(locale: SiteLocale): string {
  return getBlogPageCopy(locale as Lang).cursorReadLabel;
}

export function getBlogPreviewCardReadMoreLabel(locale: SiteLocale): string {
  return getBlogPageCopy(locale as Lang).cardReadMoreLabel;
}

export function getProjectCardReadLabel(locale: SiteLocale): string {
  return getProjectsPageCopy(locale as Lang).cursorReadLabel;
}

export function getProjectCardReadMoreLabel(locale: SiteLocale): string {
  return getProjectsPageCopy(locale as Lang).cardReadMoreLabel;
}
